import { render, staticRenderFns } from "./ConfirmReceivedAgreementFunds.vue?vue&type=template&id=11008530"
import script from "./ConfirmReceivedAgreementFunds.vue?vue&type=script&lang=js"
export * from "./ConfirmReceivedAgreementFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports